export default "__VITE_ASSET__CIuv75n1__"